import CONFIG from '@/config/global';
import { callApi, sendBeaconRequest } from '@/helpers/api';

const {
  api: {
    HOST,
    EVENTS_KEAKIE
  }
} = CONFIG;

const formatSecondsToMs = (seconds) => Math.round((seconds || 0) * 1000);

export const createStreamEventBody = ({
  episodeId = null,
  streamingContext = null,
  streamedTimeRanges = [],
  initialBufferTimeSeconds,
  totalStreamingTimeSeconds,
  totalBufferTimeSeconds
}) => {
  return {
    context: { from: streamingContext },
    event_name: 'stream',
    event_timestamp: new Date().toISOString(),
    performance: {
      initial_loading_time: formatSecondsToMs(initialBufferTimeSeconds),
      total_buffer_time: formatSecondsToMs(totalBufferTimeSeconds),
      streamed_timeranges: streamedTimeRanges,
      total_listening_time: formatSecondsToMs(totalStreamingTimeSeconds)
    },
    resource: {
      id: episodeId,
      type: 'episode'
    }
  };
};

const sendStreamingEvent = ({ params, isClosingBrowser = false }) => {
  const url = HOST(EVENTS_KEAKIE) + EVENTS_KEAKIE;
  const body = createStreamEventBody(params);

  if (isClosingBrowser) {
    const beaconResult = sendBeaconRequest({
      url,
      body
    });

    return Promise.resolve(beaconResult);
  }

  return callApi({
    url,
    method: 'POST',
    body
  }).catch(() => {});
};

export default sendStreamingEvent;